module.exports = __webpack_public_path__ + "static/media/add-a-block.5900aa85.png";